export async function AuditUpdate(
    auditResp,
    metaFecha,
    auditFrecalcoh,
    auditCuantbeb,
    auditFrecdia,
    auditParar,
    auditHacer,
    auditNeces,
    auditRemord,
    auditRecor,
    auditHerid,
    auditPreoc,
    tratamientoId,
    pacienteId,
    auditId ) {
    const formData = {
        title: `us-${pacienteId}-tr-${tratamientoId}-audit-${metaFecha}`,
        slug: `us-${pacienteId}-tr-${tratamientoId}-audit-${metaFecha}`,
        status: "publish",
        tratamiento: tratamientoId,
        paciente: pacienteId,
        meta: {
            auditResp: auditResp,
            metaFecha: metaFecha,
            auditFrecalcoh: auditFrecalcoh,
            auditCuantbeb: auditCuantbeb,
            auditFrecdia: auditFrecdia,
            auditParar: auditParar,
            auditHacer: auditHacer,
            auditNeces: auditNeces,
            auditRemord: auditRemord,
            auditRecor: auditRecor,
            auditHerid: auditHerid,
            auditPreoc: auditPreoc
        }
    };

	const authToken = sessionStorage.getItem( 'token' );
        try {
            const response = await fetch(`https://app.tavad.com/hce/wp-json/wp/v2/audit/${auditId}`, {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }

}